import _isEmpty from 'lodash/isEmpty'
import { FlipIntent } from 'cube'
import { Places } from '../RouteConsts'
import { MainKey } from '../main/main.key'
import { ParamIds } from '@/modules/RouteConsts'
import { Utf8, Base64 } from 'bula-certa-commons/encoding'

export class AnaliseBulasKey extends MainKey {

    get place() {
        return Places.analiseBulas
    }

    // :: Property hasData

    get temDados() {
        return this._intent.getParameterAsString(ParamIds.analiseBulasTemDados) === '1'
    }

    set temDados(v: boolean) {
        this._intent.setParameter(ParamIds.analiseBulasTemDados, v ? 1 : null)
    }

    // :: Property Fabricantes

    get fabricantes() {
        return getParameterB64(this._intent, ParamIds.analiseBulasFabricantes)
    }

    set fabricantes(v: string | undefined | null) {
        setParameterB64(this._intent, ParamIds.analiseBulasFabricantes, v)
    }

    // :: Property Medicamentos

    get medicamentos() {
        return getParameterB64(this._intent, ParamIds.analiseBulasMecicamentos)
    }

    set medicamentos(v: string | undefined | null) {
        setParameterB64(this._intent, ParamIds.analiseBulasMecicamentos, v)
    }

    // :: Property PrincipioAtivos

    get principioAtivos() {
        return getParameterB64(this._intent, ParamIds.analiseBulasPrincipioAtivos)
    }

    set principioAtivos(v: string | undefined | null) {
        setParameterB64(this._intent, ParamIds.analiseBulasPrincipioAtivos, v)
    }

    // :: Property Medicamentos

    get reacoes() {
        return getParameterB64(this._intent, ParamIds.analiseBulasReacoes)
    }

    set reacoes(v: string | undefined | null) {
        setParameterB64(this._intent, ParamIds.analiseBulasReacoes, v)
    }

}

// :: Utils

function setParameterB64(intent: FlipIntent, name: string, v: string) {
    intent.setParameter(name, v ? Base64.encodeUrlSafe(Utf8.encode(v)) : null)
}

function getParameterB64(intent: FlipIntent, name: string) {
    const b64Value = intent.getParameterAsString(name)
    if (b64Value) {
        return Utf8.decode(Base64.decode(b64Value))
    }
    return undefined
}